/**
 * 经销商类型
 * @export
 * @enum {number}
 */
export var EnumResellerType;
(function (EnumResellerType) {
    /** @name ISG */
    EnumResellerType["ISG"] = "12";
})(EnumResellerType || (EnumResellerType = {}));
/**
 * 经销商子类型
 * @export
 * @enum {number}
 */
export var EnumResellersubType;
(function (EnumResellersubType) {
    /** @name ISG服务商 */
    EnumResellersubType["ISGService"] = "80";
    /** @name ISG经销商 */
    EnumResellersubType["ISGReseller"] = "81";
})(EnumResellersubType || (EnumResellersubType = {}));
